export const TransactionDetailsTypeId = {
    CORE: 0,
    DEALERTRACK_PARTS: 101,
    DEALERTRACK_SERVICE: 102,
    DEALERTRACK_DEAL: 103,
} as const;

export type TransactionDetailsTypeId =
    (typeof TransactionDetailsTypeId)[keyof typeof TransactionDetailsTypeId];

export const TransactionDetailsTypeIdToName: Record<TransactionDetailsTypeId, string> = {
    [TransactionDetailsTypeId.CORE]: 'CORE',
    [TransactionDetailsTypeId.DEALERTRACK_PARTS]: 'DEALERTRACK_PARTS',
    [TransactionDetailsTypeId.DEALERTRACK_SERVICE]: 'DEALERTRACK_SERVICE',
    [TransactionDetailsTypeId.DEALERTRACK_DEAL]: 'DEALERTRACK_DEAL',
} as const;
